import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './theme';

// Layouts
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

// Pages
import LoginPage from './pages/auth/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import UsersPage from './pages/users/UsersPage';
import UserDetailsPage from './pages/users/UserDetailsPage';
import WalletsPage from './pages/wallets/WalletsPage';
import TransactionsPage from './pages/transactions/TransactionsPage';
import MarginPage from './pages/margin/MarginPage';
import KycRequestsPage from './pages/kyc/KycRequestsPage';
import KycUsersPage from './pages/kyc/KycUsersPage';
import KycUserProfilePage from './pages/kyc/KycUserProfilePage';
import KycDocumentsPage from './pages/kyc/KycDocumentsPage';
import KycDocumentDetailsPage from './pages/kyc/KycDocumentDetailsPage';
import KycDetailsPage from './pages/kyc/KycDetailsPage';
import SettingsPage from './pages/settings/SettingsPage';
import ManagerRolesPage from './pages/managers/ManagerRolesPage';
import NotFoundPage from './pages/NotFoundPage';
import AuditPage from './pages/audit/AuditPage';
import AuditLogShow from './pages/audit/AuditLogShow';
import ExchangesPage from './pages/exchanges/ExchangesPage';
import AnalyticsPage from './pages/analytics/index';
import InstrumentsPage from './pages/instruments/InstrumentsPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider 
        maxSnack={3} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
      >
        <AuthProvider>
          <Routes>
            {/* Аутентификация */}
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Navigate to="/login" replace />} />
              <Route path="login" element={<LoginPage />} />
            </Route>
            
            {/* Защищенные маршруты */}
            <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="users/:id" element={<UserDetailsPage />} />
              <Route path="wallets" element={<WalletsPage />} />
              <Route path="transactions" element={<TransactionsPage />} />
              <Route path="margin/*" element={<MarginPage />} />
              <Route path="kyc" element={<KycRequestsPage />} />
              <Route path="kyc/users" element={<KycUsersPage />} />
              <Route path="kyc/documents" element={<KycDocumentsPage />} />
              <Route path="kyc/documents/:documentId" element={<KycDocumentDetailsPage />} />
              <Route path="kyc_users/:userId" element={<KycUserProfilePage />} />
              <Route path="kyc/:id" element={<KycDetailsPage />} />
              <Route path="audit_logs" element={<AuditPage />} />
              <Route path="audit_logs/:id" element={<AuditLogShow />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="manager_roles" element={<ManagerRolesPage />} />
              <Route path="/exchanges/*" element={<ExchangesPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="instruments" element={<InstrumentsPage />} />
            </Route>
            
            {/* 404 страница */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App; 